/**
 * Translation entry point.
 *
 * DE is bundled statically (default language).
 * EN is lazy-loaded on demand via `loadTranslations("en")` to keep the
 * initial JS payload smaller. Components consume the synchronous
 * `translations` object via LanguageContext as before; the context handles
 * the async swap when the user switches to EN.
 */
import { de } from "./translations.de";
import type { Language, Translations } from "./translations.types";

export type { Language, Translations };

// Synchronous registry. DE present immediately; EN populated after first load.
export const translations: Record<Language, Translations> = {
  de,
  // Start with DE as fallback so any synchronous read before EN finishes
  // loading still returns valid strings. Replaced once `loadTranslations("en")`
  // resolves.
  en: de,
};

let enLoader: Promise<Translations> | null = null;

export const loadTranslations = async (lang: Language): Promise<Translations> => {
  if (lang === "de") return de;
  if (translations.en !== de) return translations.en;
  if (!enLoader) {
    enLoader = import("./translations.en").then((m) => {
      translations.en = m.en;
      return m.en;
    });
  }
  return enLoader;
};
